<div
  animate.enter="animate-down"
  animate.leave="animate-up"
  class="w-full min-h-screen rounded-xl flex flex-col items-center justify-center relative"
>
  <div class="-top-4 -left-6 absolute"></div>
  <img src="assets/images/emblem.png" class="w-16 md:w-20" alt="" />
  <span class="text-black text-3xl font-bold mt-5 mb-2">
    Check your
    <span class="text-primary-600">Email</span>
  </span>
  <p class="text-gray-600">
    <!-- {{ "Login Welcome Note" | concat | translate }} -->
    You will receive an email to continue with following steps.
  </p>
  <div class="w-full mt-3">
    <div class="flex flex-col gap-4 w-full py-4 px-2">
              <div class="w-full mt-2 text-center">
        <p class="text-sm md:text-md text-gray-dark">
          {{ "Done with all the steps" | concat | translate }}?
          <a routerLink="/auth" class="text-primary font-bold">
            {{ "Login instead." | concat | translate }}
          </a>
        </p>
      </div>
      <button
        (click)="navigateTo(['auth'])"
        appRipple
        class="group border border-primary-300 hover:bg-primary-50 transition-all duration-300 ease-in-out rounded-md flex gap-2 py-3 items-center justify-center text-primary-600"
      >
        <div>Sign In</div>
        <mat-icon class="group-hover:translate-x-2 transition-all duration-300 ease-in">chevron_right</mat-icon>
      </button>
    </div>
  </div>
</div>
